import { IRole, IRoleItemViewModel } from "../../../model/respone/user/IRole";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eRoleActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IRoleItemViewModel[],
    LOAD_ERRR: "",

    SHOW_EDIT_MODAL: {} as IRole| undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IRole,
    SAVE_SUCCESS: undefined,
    SAVE_ERRR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERRR: "",

};

export const eRoleActionTypeIds = generateActionTypeIds(
    eRoleActionsObj,
    "ROLE"
);
export type IRoleActionTypes = IGenericActionType<
    typeof eRoleActionsObj,
    "ROLE"
>;
